import gql from 'graphql-tag';
import { Appointment } from '../../../graphModels/appointment';

export const UPDATE_APPOINTMENT_GROUP_CURRENT_APPOINTMENT = gql`
  mutation($appointmentId: String!) {
    updateAppointmentGroupCurrentAppointment (currentAppointmentId: $appointmentId){
      ${ Appointment }
    }
  }
`;
